import {FC} from "react";

import {Text, Flex} from "@chakra-ui/react";

type DataInfoProps = {
    data: Record<string | number | symbol, any> | string;
    title: string;
    border?: string;
};

const DataInfo: FC<DataInfoProps> = ({data, title, border = "1px solid"}) => {
    return (
        <Flex
            as={"dl"}
            flexDir={"column"}
            w={"100%"}
            h={"60%"}
            justifyContent={{base: "center", sm: "flex-start"}}
            alignItems={{base: "center", sm: "flex-start"}}
            px={{base: "0.5rem", md: "1rem", lg: "1.5rem"}}
            pt={0}
            borderRight={border}
            borderColor={"lightGreyOpacity"}
        >
            <Text
                as={"dt"}
                color={"lightGrey"}
                letterSpacing={"3px"}
                fontWeight={"bold"}
                fontSize={"0.6rem"}
            >
                {title}
            </Text>
            <Flex
                flexDir={{base: "row", sm: "column"}}
                justifyContent={{base: "center", sm: "flex-start"}}
            >
                {Array.isArray(data) ? (
                    data.map((v: any, i) => {
                        return (
                            <Text
                                key={`${i}-key`}
                                as={"dd"}
                                fontWeight={"bold"}
                                fontSize={{
                                    base: "0.9rem",
                                    sm: "0.8rem",
                                    md: "1rem",
                                    lg: "1.3rem",
                                }}
                                mt={{base: 0, sm: i < 1 ? 0 : "0.5rem"}}
                                pl={{base: i < 1 ? 0 : "0.5rem", sm: 0}}
                            >
                                {v}
                            </Text>
                        );
                    })
                ) : (
                    <Text
                        as={"dd"}
                        fontWeight={"bold"}
                        fontSize={{
                            base: "0.9rem",
                            sm: "0.8rem",
                            md: "1rem",
                            lg: "1.3rem",
                        }}
                        mt={"0.5rem"}
                    >
                        {data}
                    </Text>
                )}
            </Flex>
        </Flex>
    );
};

export default DataInfo;
